// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getCurrentUserLabels } from './getCurrentUserLabels';

// To match the GSK label from BE
// https://github.com/scriptdash/scriptdash/blob/master/app/services/partnerships/gsk.rb#L8
const GSK_LABEL = 'gsk_for_you';

export const getIsGskUser = createSelector([getCurrentUserLabels], (labels) => {
  return labels.includes(GSK_LABEL);
});
